import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Login.css';

function Login() {
    const navigate = useNavigate();
    const { login, verify2FA, getDefaultRoute } = useAuth();

    const [formData, setFormData] = useState({
        email: '',
        password: '',
        rememberMe: false
    });
    const [twoFactorToken, setTwoFactorToken] = useState('');
    const [requires2FA, setRequires2FA] = useState(false);
    const [tempToken, setTempToken] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            if (requires2FA) {
                const result = await verify2FA(twoFactorToken, tempToken);
                if (result.success) {
                    navigate(getDefaultRoute(result.admin));
                } else {
                    setError(result.message);
                }
            } else {
                const result = await login(formData.email, formData.password, formData.rememberMe);

                if (result.success) {
                    if (result.requires_2fa) {
                        setRequires2FA(true);
                        setTempToken(result.temp_token);
                    } else {
                        navigate(getDefaultRoute(result.admin));
                    }
                } else {
                    setError(result.message);
                }
            }
        } catch (err) {
            setError('Authentication failed. Please check your connection.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <img src="/logo_text_horizontal.png" alt="GamesFinance" className="login-logo" />
                </div>

                {error && (
                    <div className="error-message">
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="login-form">
                    {!requires2FA ? (
                        <>
                            <div className="form-group">
                                <label htmlFor="email">Email Address</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    className="input"
                                    placeholder="name@company.com"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                    disabled={loading}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="password">Password</label>
                                <input
                                    type="password"
                                    id="password"
                                    name="password"
                                    className="input"
                                    placeholder="••••••••"
                                    value={formData.password}
                                    onChange={handleChange}
                                    required
                                    disabled={loading}
                                />
                            </div>

                            <div className="remember-row">
                                <label className="remember-label" htmlFor="rememberMe">
                                    <input
                                        type="checkbox"
                                        id="rememberMe"
                                        name="rememberMe"
                                        checked={formData.rememberMe}
                                        onChange={handleChange}
                                        disabled={loading}
                                    />
                                    <span>Remember me (365 days)</span>
                                </label>
                            </div>
                        </>
                    ) : (
                        <div className="form-group">
                            <label htmlFor="twoFactorToken">2FA Verification Code</label>
                            <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginBottom: '0.5rem' }}>
                                Enter the 6-digit code from your authenticator app.
                            </p>
                            <input
                                type="text"
                                id="twoFactorToken"
                                name="twoFactorToken"
                                className="input"
                                placeholder="000000"
                                value={twoFactorToken}
                                onChange={(e) => setTwoFactorToken(e.target.value)}
                                required
                                disabled={loading}
                                autoFocus
                                maxLength="6"
                                pattern="\d*"
                            />
                        </div>
                    )}

                    <button
                        type="submit"
                        className="login-btn"
                        disabled={loading}
                    >
                        {loading ? 'Verifying...' : (requires2FA ? 'Verify Code' : 'Sign In')}
                    </button>
                    
                    {requires2FA && (
                        <button 
                            type="button" 
                            className="btn btn-link" 
                            style={{ width: '100%', marginTop: '1rem', color: 'var(--text-secondary)', fontSize: '0.875rem' }}
                            onClick={() => setRequires2FA(false)}
                        >
                            Back to Login
                        </button>
                    )}
                </form>
            </div>
        </div>
    );
}

export default Login;
